import Autocomplete from '@material-ui/lab/Autocomplete'
import styled from 'styled-components'

interface OptionalPadding {
  padding?: number
  isExpanded?: boolean
}

export const ChipsContainer = styled.div<{ isExpanded: boolean }>`
  display: flex;
  flex-wrap: wrap;
  max-height: ${({ isExpanded }) => (isExpanded ? '500px' : '3.0rem')};
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
  position: relative;
  margin-bottom: 0.5rem; /* Espaço para o efeito de fade sem cortar os chips */
  padding-bottom: ${({ isExpanded }) => (isExpanded ? '0' : '0.8rem')};
  /* padding-bottom adicional para evitar que os chips sejam cortados no meio */
`

export const ChipOverflowIndicator = styled.div<{ show: boolean }>`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 3rem;
  background: linear-gradient(
    to right,
    transparent,
    ${({ theme }) => theme.colors.backgroundAutocomplete} 70%
  );
  opacity: ${({ show }) => (show ? 1 : 0)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none; /* Evita que o indicador interfira com cliques */
`

export const ChipsOverlay = styled.div<{ isExpanded: boolean }>`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2rem; /* Altura maior para um fade-out mais suave */
  background: linear-gradient(
    to bottom,
    rgba(255, 255, 255, 0),
    ${({ theme }) => theme.colors.backgroundAutocomplete} 85%
  );
  opacity: ${({ isExpanded }) => (isExpanded ? 0 : 1)};
  transition: opacity 0.3s ease-in-out;
  pointer-events: none; /* Evita que o overlay interfira com cliques */
  z-index: 1; /* Garante que o overlay fique por cima dos chips */
`

export const InputAutocomplete = styled(Autocomplete).attrs(
  () => {}
)<OptionalPadding>`
  padding: ${({ padding }) => padding || 1.4}rem;
  position: relative;

  .MuiChip-root {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    border-radius: 0.8rem;
    color: ${({ theme }) => theme.colors.primary};
    font-size: 1.4rem;
    font-weight: 600;
    height: 3.2rem;
    margin: 0.2rem 0.4rem;
    padding: 1.2rem 0.6rem;
    text-transform: uppercase;
    width: fit-content;
  }

  .MuiChip-deleteIcon {
    margin-left: 0.6rem;
  }

  .MuiAutocomplete-inputRoot {
    font-size: 1.4rem;
    background-color: ${({ theme }) => theme.colors.backgroundAutocomplete};
  }

  .MuiInputLabel-root {
    font-size: 1.2rem;
    transform: translate(${({ theme }) => theme.spacings.xsmall}, 1.9rem)
      scale(1);
  }

  .MuiInputLabel-outlined.MuiInputLabel-shrink {
    transform: translate(14px, -6px) scale(0.71428);
  }

  .MuiOutlinedInput-input {
    font-size: 1.1rem;
    padding: ${({ padding }: any) =>
        padding === 'large' ? '0.6rem' : '0.2rem'}
      0;

    &.MuiOutlinedInput-inputMultiline {
      padding: ${({ padding }: any) =>
          padding === 'large' ? '0.6rem' : '0.2rem'}
        0;
    }
  }

  label.Mui-focused {
    color: ${({ theme }) => theme.colors.focusForm};
  }

  .MuiOutlinedInput-root {
    fieldset {
      legend {
        font-size: 1.05rem;
      }
      border-color: ${({ border, theme }) =>
        border === 'dark' ? theme.colors.darkGray : theme.colors.Gray};
      opacity: 1;
    }

    &:hover fieldset {
      border-color: ${({ theme }) => theme.colors.hoverForm};
    }

    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.colors.focusForm};
    }
  }

  .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline {
    border-color: ${({ theme }) => theme.colors.error};
  }

  .MuiFormLabel-root.Mui-error {
    color: ${({ theme }) => theme.colors.error};
  }

  .MuiFormHelperText-root.Mui-error {
    color: ${({ theme }) => theme.colors.error};
    font-size: 1rem;
    font-weight: 600;
    padding-left: ${({ theme }) => theme.spacings.xxxsmall};
  }
`

export const AlertIcon = styled.div`
  display: flex;
  color: ${({ theme }) => theme.colors.error};

  position: relative;
  bottom: 1.4rem;
  height: 0;
  img {
    height: 1rem;
  }
`

export const TrashIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: end;
  background: red;
`

export const EmptyRemoveButton = styled.div`
  width: 0;
  height: 0;
  margin-left: -0.5rem !important;
`
